export default "__VITE_ASSET__UXPUPZhy__"